export default __webpack_public_path__ + "static/media/Marble canvas_primary.26090d72.jpg";